import { Box, Container, Grid } from '@mui/material';
import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';
import { SttFullDialog } from '../../../sporttia/dialogs/SttFullDialog';
import { SttLabelForm } from '../../../sporttia/labels/SttLabelForm';

type Trigger = {
    request: string;
    answer: string;
};

type Props = {
    trigger: Trigger | null;
    onClose: () => void;
};

export default function ConfigurationTriggerDialog({
    trigger = null,
    onClose,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    return (
        <SttFullDialog
            open={trigger !== null}
            onClose={onClose}
            title={t('IntegrationOperationsTitle')}
        >
            <Container>
                <Paper>
                    <Box mt={2} p={2}>
                        {trigger && (
                            <Grid container spacing={3}>
                                <SttLabelForm
                                    grid
                                    md={8}
                                    title="Request"
                                    text={trigger.request}
                                />

                                <SttLabelForm
                                    grid
                                    md={8}
                                    title="Answer"
                                    text={trigger.answer}
                                />
                            </Grid>
                        )}
                    </Box>
                </Paper>
            </Container>
        </SttFullDialog>
    );
}
